'use client';
import { IBlogContent, blogContent, blogTags } from '@/utils/blog';
import React, { useMemo, useState } from 'react';
import styles from '@/assets/styles/pages/blog/Blog.module.scss';
import { MimaText, Searchbar, PageLayout2 } from '@/components';
import Link from 'next/link';
import Image from 'next/image';
import { IoArrowForward } from 'react-icons/io5';
import { Rectangle } from '@/assets/img/ImgList';

const Blog = () => {
  const navItems = blogTags;

  const [selectedNav, setSelectedNav] = useState(0);
  const [selectedMenu, setSelectedMenu] = useState('All');
  const [filteredPosts, setFilteredPosts] = useState<IBlogContent[]>([]);

  const postsAvailable: IBlogContent[] = useMemo(() => {
    if (selectedMenu === 'All') {
      return blogContent.sort((a: any, b: any) => b._id - a._id);
    } else {
      return blogContent
        .filter((x) => {
          return x.tags.includes(selectedMenu);
        })
        .sort((a: any, b: any) => b._id - a._id);
    }
  }, [selectedMenu]);
  return (
    <PageLayout2>
      <div className={styles.title}>
        <MimaText variant='h1' align="center" color='var(--color-whilte)'>
          Blog
        </MimaText>
        <MimaText variant="body" align="center" color='var(--color-whilte)'>
          Learn more about growing and managing your fashion business with Fashcreatives.
        </MimaText>
        <Image
          src={Rectangle}
          alt='Rectangle'
          width={500}
          height={500}
          className={styles.slow}
        />
        <Image
          src={Rectangle}
          alt='Rectangle'
          width={500}
          height={500}

        />
      </div>
      <div className={styles.nav}>
        <div className={styles.nav__item}>
          {navItems.map((item, i) => (
            <nav
              key={i}
              className={selectedNav === i ? styles.nav__item__selected : ''}
              onClick={() => {
                setSelectedNav(i);
                setSelectedMenu(item);
              }}
            >
              {item}
            </nav>
          ))}
        </div>

        <Searchbar
          placeholder="Search Article Titles"
          input={postsAvailable}
          loading={false}
          output={setFilteredPosts}
          handleFilter={(item, searchQuery) => {
            return item?.title?.toLowerCase()?.includes(searchQuery);
          }}
        />
      </div>
      <section className={styles.container}>
        {filteredPosts.length === 0 ? (
          <>
            <MimaText align="center" variant="h3" color="var(--color-grey)" mt={5} mb={5}>
              {' '}
              Regrettably, the title you entered did not match any existing articles in our database. Kindly consider searching for an alternative
              article title
            </MimaText>
          </>
        ) : (
          <div className={styles.blog__list}>
            {filteredPosts?.map((blog) => (
              <Link href={blog.link} key={blog._id}>
                <div className={styles.blog__list__single}>
                  <div className={styles.blog__list__single__img__container}>
                    <Image src={blog.titleImage} alt={blog.title} className={styles.blog__list__single__img} />
                  </div>

                  <div className={styles.blog__list__single__flex}>
                    <div className={styles.blog__list__single__tags}>
                      {blog.tags.map((x, i) => (
                        <div key={i}>{x}</div>
                      ))}
                    </div>
                    <MimaText variant="small">{blog.readTime} Read</MimaText>
                  </div>
                  <MimaText variant="subtitleBold" className={styles.blog__list__single__title}>{blog.title}</MimaText>
                  <MimaText className={styles.blog__list__single__summary}>{blog.summary}</MimaText>
                  <div className={styles.blog__list__single__read}>
                    Read More <IoArrowForward />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </PageLayout2>
  );
};

export default Blog;
